document.addEventListener('DOMContentLoaded', function () {
    $('.input-daterange').datepicker({
        clearBtn: true,
        language: "pt-BR",
        orientation: "bottom auto",
        autoclose: true,
        todayHighlight: true
    });
});
